import { useMatches } from 'react-router';

import type { ScreenId } from '@shared/config';

/** T3 `Guest / Center` 의 카드 폭(Figma `card [login, narrow, none]`, DD-15 H6) */
export type GuestCard = 'login' | 'narrow' | 'none';

/**
 * 화면 라우트의 `handle.screen`. 템플릿 레이아웃이 읽는다.
 * - `backBar`: BackBar 를 보일지(T1 · T2). 기본 켬. 메인 · 404 · PF 포트폴리오 상세는 끔
 * - `card`: T3 카드 폭. 기본 narrow
 * - `menuRoot`: 헤더 · 계정 메뉴로 여는 화면(S13 ~ S20, S17 제외). BackBar 에 자기 이름만 쓴다(Figma). 갈 곳은 화면 트리(screen-tree.ts)
 */
export interface ScreenInfo {
  id: ScreenId;
  backBar?: boolean;
  menuRoot?: boolean;
  card?: GuestCard;
}

export interface ScreenHandle {
  screen: ScreenInfo;
}

function isScreenHandle(handle: unknown): handle is ScreenHandle {
  return (
    typeof handle === 'object' &&
    handle !== null &&
    'screen' in handle &&
    typeof (handle as ScreenHandle).screen?.id === 'string'
  );
}

/** 가장 안쪽 화면 라우트의 정보 */
export function resolveScreen(matches: readonly { handle?: unknown }[]): ScreenInfo | null {
  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const handle = matches[index]?.handle;
    if (isScreenHandle(handle)) return handle.screen;
  }
  return null;
}

export function useScreenInfo(): ScreenInfo | null {
  return resolveScreen(useMatches());
}
